import { render, staticRenderFns } from "./TutorialManagement.vue?vue&type=template&id=1000088c&scoped=true"
import script from "./TutorialManagement.vue?vue&type=script&lang=js"
export * from "./TutorialManagement.vue?vue&type=script&lang=js"
import style0 from "./TutorialManagement.vue?vue&type=style&index=0&id=1000088c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1000088c",
  null
  
)

export default component.exports